module.exports = __webpack_public_path__ + "static/media/orderConfirmed.18471035.svg";